import { cn } from '@utils/cn';
import { render } from 'storyblok-rich-text-react-renderer-ts';

import { Title } from '../types/Franchises';
import { isStoryblokRichTextPresent } from '../utils/renderStoryblokRichText';
import { RichTextLink } from './RichTextLink';

const TITLE_SIZE_CLASSES: Record<Title['titleSize'], string> = {
  '': 'text-lg md:text-xl',
  xl: 'text-lg md:text-xl',
  lg: 'text-md md:text-lg',
  md: 'text-md',
};

interface ContentBlockTitleProps {
  blok: Title;
  /** Extra heading classes, e.g. a section's own weight. */
  headingClassName?: string;
}

export const ContentBlockTitle = ({
  blok,
  headingClassName,
}: ContentBlockTitleProps) => (
  <div className="mx-auto flex w-full flex-col items-center gap-5 text-center md:max-w-xl">
    <h2
      className={cn(
        'font-bold',
        TITLE_SIZE_CLASSES[blok.titleSize],
        headingClassName,
      )}
    >
      {blok.title}
    </h2>
    {isStoryblokRichTextPresent(blok.description) && (
      <div className="rich-text-content text-sm-mobile md:text-sm">
        {render(blok.description, { markResolvers: { link: RichTextLink } })}
      </div>
    )}
  </div>
);
